import { MenuItem } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import HamburgerIcon from "../../../components/icons/HamburgerIcon";
import Logo from "../../../components/icons/Logo";
import { dashboardAction } from "../../../redux/features/dashboardSlice";
import "./Header.scss";
import { AuthHelpers } from "../../../utils/auth.helpers";
import AgentMenuDetails from "./AgentMenuDetails";
import AgencyMenuDetails from "./AgencyMenuDetails";
import { LocalStorageHelpers } from "../../../utils/helpers/localstorage.helpers";
import { IProfileAgency, IProfileAgent } from "../../../@types/api-data.types";
import {
  getAgentProfileImageUrl,
  getCdnImageUrl,
  getImageUrl,
} from "../../../utils/helpers/common";
import { AgentApi } from "../../../utils/api/Agent";
import { AgencyApi } from "../../../utils/api/Agency";
import { RootState } from "../../../redux/store";
import { Link, useNavigate } from "react-router-dom";
import { CommonEnums } from "../../../enums/common.enums";
import { clientRoutes } from "../../../utils/routes";
import MainLogo from "../../../components/icons/MainLogo";
import NotificationIcon from "../../../components/icons/NotificationIcon";
import MainMobileIcon from "../../../components/icons/MainMobileIcon";
import HeaderNotificationIcon from "../../../components/icons/HeaderNotificationIcon";
import ProfileImage from "../../../components/profileImage/ProfileImage";
import toast from "react-hot-toast";
import { UserApi } from "../../../utils/api/User";

const menuTypes = {
  logout: "logout",
};

const getProfileImageUrl = (uploadRecord: any) => {
  if (!uploadRecord) return "";

  return getAgentProfileImageUrl(uploadRecord);
};

const Header = () => {
  let profileData = useSelector(
    (state: RootState) => state?.dashboard?.profileData,
  );
  const [state, setState] = useState<any>({
    isLoading: false,
    profileMenu: false,
    userData: null,
    profile_image: "",
    profile_image_ref: null,
  });

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setState({
      ...state,
      profileMenu: true,
    });
  };

  const onClickHamburger = () => {
    dispatch(dashboardAction?.setsideBar());
  };

  // const getData = async () => {
  //   let data: any = LocalStorageHelpers?.getUserData();
  //   setState({
  //     ...state,
  //     userData: data,
  //     profile_image: data?.profile_image_ref?.compressed_file_path,
  //   });
  // };

  const getProfileData = async () => {
    let data: any = LocalStorageHelpers?.getUserData();
    setState({
      ...state,
      isLoading: true,
    });
    let res = await UserApi?.getUserByid(data?._id);

    if (res?.data?.success) {
      let resData = res?.data?.data;
      setState({
        ...state,
        userData: resData,
        profile_image: resData?.profile_image_ref?.compressed_file_path,
        profile_image_ref: resData?.profile_image_ref,
      });
    } else {
      setState({
        ...state,
        isLoading: true,
      });
      toast.error(res?.data?.message || "Internal server error!");
    }
  };

  const handleLogout = () => {
    AuthHelpers.logOut();
  };

  const handleClose = () => {
    setState({
      ...state,
      profileMenu: false,
    });
  };

  const handleCloseMenuItem = (link: string) => {
    navigate(link);
    handleClose();
  };

useEffect(() => {
  let lastScrollY = window.scrollY;

  const handleScroll = () => {
    const header = document.querySelector(".top-header");
    const currentScrollY = window.scrollY;

    if (currentScrollY > 50) {
      header?.classList.add("scrolled");
    } else {
      header?.classList.remove("scrolled");
    }

    if (currentScrollY > lastScrollY && currentScrollY > 80) {
      header?.classList.add("header-hidden");
    } else if (lastScrollY - currentScrollY >= 20 || currentScrollY <= 80) {
      header?.classList.remove("header-hidden");
    }

    lastScrollY = currentScrollY;
  };

  window.addEventListener("scroll", handleScroll);

  return () => window.removeEventListener("scroll", handleScroll);
}, []);

  useEffect(() => {
    // getData();
    getProfileData();
  }, [profileData]);

  const menuItem = [
    {
      id: "1",
      type: "",
      menuName: "View Profile",
      link: `${clientRoutes.profile}/view/${state?.userData?._id}?type=${CommonEnums?.agentDetailsType?.info?.key}`,
    },
    {
      id: "2",
      type: "",
      menuName: "Settings",
      link: "",
    },

    {
      id: "3",
      type: menuTypes.logout,
      menuName: "Logout",
      link: "",
    },
  ];

  const profileImageSrc =
    getProfileImageUrl(state?.profile_image_ref) || state?.profile_image;

  return (
    <div className="header-main-container">
      <div className="top-header">
        <div className={`header-left-contain`}>
          <div className="hamburger-icon" onClick={onClickHamburger}>
            <HamburgerIcon />
          </div>
          <div className="logo">
            <div className="web-icon">
              <MainLogo />
            </div>
            <div className="mobile-icon">
              <MainMobileIcon />
            </div>
          </div>
        </div>

        <div className="header-divider"></div>

        <div className="profile-image-and-notification-icon">
          <button
            id="basic-button"
            onClick={handleClick}
            className="profile-logo-btn"
          >
            <ProfileImage
              uploadRecord={state?.profile_image_ref}
              url={profileImageSrc}
              width={40}
              height={40}
            />
          </button>
        </div>
      </div>

      <div
        className={`profile-menu-container ${
          state?.profileMenu ? "" : "display-none"
        }`}
      >
        <div className="profile-menu-bg" onClick={handleClose}></div>

        <div className="profile-menu-box">
          <div className="header-menu-top-contain-container">
            <div className="header-profile-image">
              <ProfileImage
                uploadRecord={state?.profile_image_ref}
                // url={state?.profile_image || ""}
                url={profileImageSrc}
                width={60}
                height={60}
              />
            </div>
            <div className="header-menu-profile-top-contain">
              <button className="header-menu-profile-btn">Super Admin</button>

              <p className="header-menu-profile-name">{`${state?.userData?.first_name} ${state?.userData?.last_name}`}</p>
              <p className="header-menu-profile-name-email">
                {state?.userData?.email || ""}
              </p>
            </div>
          </div>
          <div className="header-menu-profile-border"></div>
          <div className="menu-navigation-contain-container">
            {menuItem?.map((item) => {
              if (item?.type === menuTypes?.logout) {
                return (
                  <MenuItem onClick={handleLogout} key={item?.id}>
                    {item?.menuName}
                  </MenuItem>
                );
              } else {
                return (
                  <Link to={item?.link}>
                    <MenuItem key={item?.id} onClick={handleClose}>
                      {item?.menuName}
                    </MenuItem>
                  </Link>
                );
              }
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
